import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  FormControlLabel,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useGeneralChargesContext } from 'contexts/GeneralChargesContext';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontSize: '1.8rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

interface Props {
  currentChargeTabSelected: string;
}

export const Header: FC<Props> = ({ currentChargeTabSelected }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { hideTax, setHideTax } = useGeneralChargesContext();

  return (
    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box style={{ display: 'flex' }}>
        <Typography className={classes.title} variant="h1">
          {t('orders:chargesTitle')}
        </Typography>
        <Tooltip title={t('orders:tutorialTooltip')}>
          <IconButton size="small" style={{ width: '2rem' }}>
            <FontAwesomeIcon icon="question-circle" size="sm" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box style={{ display: 'flex', gap: '16px' }}>
        {['A', 'B', 'C', 'E', 'F', 'G', 'H'].includes(currentChargeTabSelected) && (
          <FormControlLabel
            control={<Switch checked={hideTax} onChange={(_, value) => setHideTax(value)} />}
            label={t('orders:hideTaxLabel')}
          />
        )}
      </Box>
    </Box>
  );
};
